import { Info } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

type Props = {
  children: React.ReactNode
  className?: string
  label: React.ReactNode | string
  tooltip?: string
}

const FloatingLabel = ({ children, className, label, tooltip }: Props) => {
  return (
    <div className={`flex flex-col ${className || ''}`}>
      <div className="inline-flex items-center">
        <label className="floating_label">{label}</label>
        {tooltip && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="ml-2 h-4 w-4 cursor-help" />
            </TooltipTrigger>
            <TooltipContent>
              <p>{tooltip}</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      {children}
    </div>
  )
}

export default FloatingLabel
